import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Query messages list

export const query = graphql(`
    query AppMessagesQuery($filter: MessageFilterType) {
        messages(filter: $filter) {
            id
            datetime
            senderName
            read
            archived
            subject
            content
            contentFormat
            canReply
        }
    }
`);

export type IMessage = ResultOf<typeof query>["messages"][number];

// Query sent messages list

export const sentQuery = graphql(`
    query AppSentMessagesQuery {
        learningCoachMessageList {
            id
            datetime
            subject
            content
            contentFormat
        }
    }
`);

export type ISentMessage = ResultOf<typeof sentQuery>["learningCoachMessageList"][number];

// Toggle message read status mutation

export const toggleReadMutation = graphql(`
    mutation AppMessageToggleReadMutation($ids: [ID!]!, $read: Boolean!) {
        messageToggleRead(ids: $ids, read: $read) {
            error
            messages { id }
        }
    }
`);

// Toggle message archive status mutation

export const toggleArchiveMutataion = graphql(`
    mutation AppMessageToggleArchivedMutation($ids: [ID!]!, $archived: Boolean!) {
        messageToggleArchived(ids: $ids, archived: $archived) {
            error
            messages { id }
        }
    }
`);

// Delete message(s) mutation

export const deleteMutation = graphql(`
    mutation AppMessageDeleteMutation($ids: [ID!]!) {
        messageDelete(ids: $ids) {
            error
            messages { id }
        }
    }
`);

// Message thread query

export const replyQuery = graphql(`
    query AppMessageReplyThreadQuery($id: ID!) {
        message(id: $id) {
            id
            replyThread {
                id
                senderName
                subject
                content
                contentFormat
            }
        }
    }
`);
